<template>
  <div>
    <p class="my-5">
      If you have completed an e-Portfolio on your school careers website, you can use that here.
      When you click the button below, it will check for your e-Portfolio and then provide a link to
      it.
    </p>
    <template v-if="!CTportfolio">
      <p class="my-5">Click on the button below to use the e-portfolio link</p>
      <button class="btn btn-secondary btn-size-medium" @click="useCTPortfolio">
        Use e-Portfolio from School Careers Website
      </button>
      <vs-progress indeterminate color="primary" v-if="downloadingCTPortfolio"></vs-progress>
    </template>
    <template v-else>
      <div style="overflow: hidden">
        <a
          :href="CTportfolio"
          target="_blank"
          class="btn btn-secondary btn-size-medium includedIcon my-5 mr-5"
        >
          <external-link-icon />View e-Portfolio
        </a>
        <button
          class="btn btn-secondary danger btn-size-medium includedIcon my-5"
          @click="removeEportfolio"
          style="float: left"
        >
          <trash-2-icon />Remove e-Portfolio
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import store from '@/store/store';
import theApi from '@/mixins/theApi';
import { ExternalLinkIcon, Trash2Icon } from 'vue-feather-icons';

export default {
  components: {
    ExternalLinkIcon,
    Trash2Icon,
  },
  computed: {
    prework() {
      return store.getters['authStudent/prework'];
    },
  },
  data() {
    return {
      downloadingCTPortfolio: false,
      CTportfolio: false,
    };
  },
  methods: {
    async useCTPortfolio() {
      this.downloadingCTPortfolio = true;
      theApi.methods.makeCall(false, 'apply/eportfolio/use', 'get', null, null, true).then(
        (data) => {
          this.CTportfolio = data.url;

          const pw_data = {
            status_section: 'section_apply',
            section: 'application_url',
            data: data.url,
            application_type: 3,
          };
          store.dispatch('authStudent/completePreworkSection', pw_data);
        },
        () => {},
      );
      this.downloadingCTPortfolio = false;
    },
    async removeEportfolio() {
      theApi.methods.makeCall(false, 'apply/eportfolio/remove', 'post').then(() => {
        this.CTportfolio = false;

        const pw_data = {
          status_section: 'section_apply',
          section: 'application_url',
          data: null,
          application_type: null,
        };
        store.dispatch('authStudent/completePreworkSection', pw_data);
      });
    },
  },
  mounted() {
    if (this.prework.application_url) this.CTportfolio = this.prework.application_url;
    //this.getApplyEportfolio();
  },
};
</script>
